import { useQuery } from '@tanstack/react-query'
import { liveCheckinTasksDefaultsService } from '../../services/lives-checkins-tasks-defaults'

export const TASKS_DEFAULTS_KEY = 'getLiveCheckinTasksDefaults'

export function useGetTasksDefaults() {
  const { data, isLoading } = useQuery({
    queryKey: [TASKS_DEFAULTS_KEY],
    queryFn: () =>
      liveCheckinTasksDefaultsService.getList({
        take: 500,
        active: true,
        deleted: false,
      }),
  })

  return {
    tasksDefaults: data?.data ?? [],
    isLoading,
  }
}
